import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class DattoMappingsEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspDattoMappings),
            mergeMap(() =>
                this.ajax.get('/api/octiga/v3/msp/datto/tenant-mappings').pipe(
                    map((items) => actions.loadMspDattoMappingsSuccess({ items })),
                    catchError((error) => of(actions.loadMspDattoMappingsFailure({ error }))),
                ),
            ),
        ),
    );

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.updateMspDattoMappings),
            mergeMap(({ items }) =>
                this.ajax.put('/api/octiga/v3/msp/datto/tenant-mappings', items).pipe(
                    map(() => actions.updateMspDattoMappingsSuccess({ items })),
                    catchError((error) => of(actions.updateMspDattoMappingsFailure({ error }))),
                ),
            ),
        ),
    );
    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
